import noop from 'lodash/noop';

export const defaultProps = {
  resetDrillDown: noop,
  pushDrilldownFilter: noop,
  applyFilter: noop,
  onCompareAction: noop,
  isCompareMode: false,
};
